(() => {
  const root = document.querySelector('[data-delivery-contact]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const status = root.querySelector('[data-delivery-status]');
  const trigger = root.querySelector('[data-delivery-chat]');
  const setStatus = (text) => {
    if (status) status.textContent = text;
  };
  let timer;
  let attempts = 0;
  let opened = false;
  let cachedLauncher = null;

  // Shopify Inbox is undocumented: there is no supported "open the chat" API,
  // and its markup has changed more than once. The previous version of this
  // file matched exactly one selector, so the day that selector stopped
  // matching, this page silently never opened chat. Everything below is
  // therefore a list of strategies tried in order, cheapest and most stable
  // first, so one more rename does not take the page down again.

  const CHAT_LABEL = /chat|message|support/i;

  // Walk open shadow roots looking for the launcher. Bounded on both depth and
  // nodes visited: this runs on a poll, and an unbounded walk of a large page
  // every 1.5s is a real cost on low-end phones.
  function deepFind(predicate) {
    const MAX_NODES = 4000;
    let seen = 0;
    const queue = [document];
    while (queue.length) {
      const scope = queue.shift();
      let nodes;
      try {
        nodes = scope.querySelectorAll('*');
      } catch (_) {
        continue;
      }
      for (const node of nodes) {
        if (++seen > MAX_NODES) return null;
        if (predicate(node)) return node;
        if (node.shadowRoot) queue.push(node.shadowRoot);
      }
    }
    return null;
  }

  function isLauncher(node) {
    const role = node.getAttribute && node.getAttribute('role');
    const tag = node.tagName;
    if (tag !== 'BUTTON' && role !== 'button') return false;
    // The historic selector, kept as the strongest signal.
    if (node.getAttribute('part') === 'activator') return true;
    const label = node.getAttribute('aria-label') || '';
    const title = node.getAttribute('title') || '';
    return CHAT_LABEL.test(label) || CHAT_LABEL.test(title);
  }

  function openInbox() {
    // 1. The element's own methods, if it ever exposes one. Cheapest and the
    //    only approach that does not depend on markup.
    const chat = document.querySelector('shopify-chat');
    if (chat) {
      for (const method of ['show', 'open', 'maximize', 'expand']) {
        if (typeof chat[method] === 'function') {
          chat[method]();
          return true;
        }
      }
    }
    // 2. A launcher we already found on a previous tick.
    if (cachedLauncher && cachedLauncher.isConnected) {
      cachedLauncher.click();
      return true;
    }
    // 3. Search the page and open shadow roots.
    const launcher = deepFind(isLauncher);
    if (launcher) {
      cachedLauncher = launcher;
      if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
      return true;
    }
    return false;
  }

  // Tawk.to is installed on this store but its chat is not enabled, so this
  // normally does nothing. Kept as a cheap safety net in case it is switched
  // on later; it costs one property check per attempt.
  function openTawk() {
    const api = window.Tawk_API;
    if (!api || typeof api.maximize !== 'function') return false;
    api.maximize();
    return true;
  }

  function chatPresent() {
    return Boolean(
      document.querySelector('shopify-chat') ||
        cachedLauncher ||
        deepFind(isLauncher) ||
        (window.Tawk_API && typeof window.Tawk_API.maximize === 'function'),
    );
  }

  function done() {
    opened = true;
    clearInterval(timer);
    setStatus('');
    return true;
  }

  function open() {
    try {
      if (openInbox()) return done();
    } catch (_) {
      /* fall through */
    }
    try {
      if (openTawk()) return done();
    } catch (_) {
      /* keep retrying */
    }
    return false;
  }

  function giveUp() {
    clearInterval(timer);
    // Be honest about which situation this is. Telling someone it is "still
    // loading" when no chat widget exists just makes them wait longer.
    setStatus(
      chatPresent()
        ? 'Chat is taking longer than usual. Try Open chat again, or use the chat icon in the corner.'
        : 'Live chat could not load. Please contact support below and we will reply by email.',
    );
  }

  function start() {
    clearInterval(timer);
    attempts = 0;
    setStatus('Opening Live Chat…');
    if (open()) return;
    timer = setInterval(() => {
      if (open()) return;
      attempts += 1;
      if (attempts === 8) setStatus('Still connecting to Live Chat…');
      if (attempts >= 20) giveUp();
    }, 1500);
  }

  if (trigger) {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      // Let the widget finish processing the outside click before opening.
      window.setTimeout(start, 0);
    });
  }
  document.addEventListener('shopifyInboxReady', () => {
    if (!opened) open();
  });
  window.setTimeout(start, 1500);
  window.addEventListener('pagehide', () => clearInterval(timer), { once: true });
})();
